<template>
  <!-- PricePro-style filter PANEL for the Ordering Grid — mirrors the drawers on
       TPR / Ad Planner / Financial Search. Rendered inline as a flex sibling of
       the grid so it PUSHES the grid over (no overlap). Edits stage in the local
       model; nothing hits the server until Apply (which emits only the ACTIVE
       params — the same shape the old SearchFilters dropdown emitted, so the
       server contract is unchanged). -->
  <div class="order-filter-panel d-flex flex-column" style="height:100%;">
    <v-toolbar flat dense color="toolbar" class="flex-grow-0">
      <v-icon left>mdi-filter-variant</v-icon>
      <v-toolbar-title class="text-subtitle-1 font-weight-medium">Filters</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-divider />

    <div class="pa-4 flex-grow-1" style="overflow-y:auto;">
      <v-autocomplete
        v-model="model.page_name"
        :items="pageOptions"
        item-text="page_name"
        item-value="page_name"
        label="Page"
        clearable auto-select-first
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <v-autocomplete
        v-if="showArgFilters"
        v-model="model.position_name"
        :items="featureTypeOptions"
        item-text="position_name"
        item-value="position_name"
        label="Feature Type"
        clearable auto-select-first
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <!-- Feature Text + Item ID filters removed per Sarah (7/15) — covered by
           the toolbar's "Search all columns" box. Model keys retained so any
           stored sessionStorage state stays harmless. -->
      <v-autocomplete
        v-model="model.department"
        :items="departmentOptions"
        item-text="department"
        item-value="department"
        label="Department"
        clearable auto-select-first
        dense outlined hide-details background-color="input"
        class="mb-4" :menu-props="{ maxHeight: 260 }" />
      <v-checkbox
        v-model="model.is_shipper"
        label="Shippers/Pallets"
        hide-details
        class="mt-0 mb-2" />
      <v-checkbox
        v-if="showArgFilters && showOrderFilters"
        v-model="model.has_orders"
        label="Items With Orders"
        hide-details
        class="mt-0 mb-2" />
      <v-checkbox
        v-if="showArgFilters && showOrderFilters"
        v-model="model.has_notes"
        label="Features With Notes"
        hide-details
        class="mt-0 mb-2" />
    </div>

    <v-divider />
    <div class="pa-3 d-flex align-center flex-grow-0">
      <v-btn text small :disabled="!stagedCount" @click="clearAll">Clear all</v-btn>
      <v-spacer />
      <v-btn color="primary" small @click="apply">Apply</v-btn>
    </div>
  </div>
</template>

<script>
const emptyModel = () => ({ page_name: '', position_name: '', department: '', is_shipper: false, has_orders: false, has_notes: false })

export default {
  name: 'OrderGridSearchFilters',
  props: {
    // Committed params object (only active keys) — same shape the view's
    // itemFilters watcher / server query has always consumed.
    value: { type: Object, default: () => ({}) },
    pageOptions: { type: Array, default: () => [] },
    departmentOptions: { type: Array, default: () => [] },
    featureTypeOptions: { type: Array, default: () => [] },
    showArgFilters: { type: Boolean, default: false },
    showOrderFilters: { type: Boolean, default: false }
  },
  data () {
    return { model: { ...emptyModel(), ...this.value } }
  },
  computed: {
    stagedCount () {
      const m = this.model
      let n = 0
      ;['page_name', 'position_name', 'department'].forEach(k => { if (m[k]) n += 1 })
      ;['is_shipper', 'has_orders', 'has_notes'].forEach(k => { if (m[k]) n += 1 })
      return n
    }
  },
  watch: {
    value: {
      handler (v) { this.model = { ...emptyModel(), ...(v || {}) } },
      deep: true
    }
  },
  methods: {
    clearAll () {
      this.model = emptyModel()
      this.emitActive()
    },
    apply () {
      this.emitActive()
      this.$emit('close')
    },
    // Emit ONLY the active keys (truthy values), matching the old SearchFilters
    // emit shape. Iterates the CURRENT field set (emptyModel) so retired filters
    // (feature_text/item_id) lingering in sessionStorage are dropped on Apply.
    // Also persist to sessionStorage for continuity across reloads.
    emitActive () {
      const m = this.model
      const out = {}
      for (const k of Object.keys(emptyModel())) {
        const v = m[k]
        if (typeof v === 'boolean' ? v : String(v || '').trim() !== '') out[k] = v
      }
      this.$emit('input', out)
      if (Object.keys(out).length > 0) {
        sessionStorage.setItem('search_filters', JSON.stringify(out))
      } else {
        sessionStorage.removeItem('search_filters')
      }
    }
  }
}
</script>
